import api from '@/services/api/api';
import axios from 'axios';
import store from '@/store';

const initialState = () => ({
  rating: null
});

const formHeaders = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };

export default {
  namespaced: true,
  state: initialState,
  getters: {
    rating: (state) => state.rating
  },
  mutations: {
    SET_RATING(state, rating) {
      state.rating = Array.isArray(rating) ? {} : rating;
    }
  },
  actions: {
    async isRated({ commit, state }, args) {
      const params = {
        calendar_id: args.calendar_id,
        class_number: args.class_number,
      }

      const { data } = await api.get('/course/calendar/class/summary/rate', { params });
      commit('SET_RATING', data);
      return data;
    },
    async rate({ commit, state }, args) {
      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const contacto_id = store.state.Auth.user.userId;

      const params = {
        calificacion: args.calificacion,
        ...(args.comentario?.trim() && {
          comentario: args.comentario.trim()
        })
      };

      try {
        const response = await axios.post(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + `alumni/contactos/${contacto_id}/calendarios/${args.calendario_id}/clase/${args.clase_id}/resumen-calificacion`,
          params,
          options
        );

        commit('SET_RATING', {
          calendar_id: Number(args.calendario_id),
          class_id: Number(args.clase_id),
          qualification: Number(args.calificacion),
          comment: args.comentario,
        });

        return response.data
      } catch (err) {
        console.error(err);
      }
    }
  },
};
